import { render } from "./SidenavList.vue?vue&type=template&id=73343742"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__